import { authRoutePaths } from '@manager/modules/auth/auth-route-paths';
import AuthAttemptPage from '@manager/modules/auth/views/AuthAttemptPage.vue';
import AuthPage from '@manager/modules/auth/views/AuthPage.vue';
import LoginPage from '@manager/modules/auth/views/LoginPage.vue';
import LogoutPage from '@manager/modules/auth/views/LogoutPage.vue';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const authRoutes: RouteMetaConfig[] = [
  {
    path: authRoutePaths.login,
    name: routeNames.login,
    component: LoginPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: authRoutePaths.auth,
    name: routeNames.auth,
    component: AuthPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: authRoutePaths.authAttempt,
    name: routeNames.authAttempt,
    component: AuthAttemptPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: authRoutePaths.logout,
    name: routeNames.logout,
    component: LogoutPage,
    meta: {
      requiresAuth: false,
    },
  },
];
